import React, { Component } from "react";
import Content from "../components/Content";
import classNames from 'classnames'
import { Image } from 'react-bootstrap'

const sectionList = [

  {
    title: "Display Compatibility",
    content: <p>Our tiny player is easy to setup.
      Lumio works seamlessly with different display orientations.
      It even works on LEDs with custom resolution.
    </p>,
    image: '//cdn.lumio.id/w500/topng/s3:ap-southeast-1:lumio:web/DisplayCompatibility.png',
    position: 'left'
  },
  {
    title: "Detail Insight",
    content: <p>Lumio keep tracks of when and where the content has been played.
      View and export metrics of your content, device performance and apps data using our reporting tool.
      Detailed log proof report is generated automatically every month.
    </p>,
    image: '//cdn.lumio.id/w500/topng/s3:ap-southeast-1:lumio:web/DetailInsight.png',

  },
  {
    title: "Content Delivery",
    content: <p>Set when and where you want to display your content from anywhere and anytime.
      You can schedule time specific contents to increase audience engagement.
    </p>,
    image: '//cdn.lumio.id/s3:ap-southeast-1:lumio:web/ContentDelivery.gif',
    position: 'left'
  },
  {
    title: "Monitoring",
    content: <p>Our Advance Monitoring tools enables you to check the status of the player,
      get activity log or send a remote command to the player for maintenance purposes.
    </p>,
    image: '//cdn.lumio.id/w500/topng/s3:ap-southeast-1:lumio:web/Monitoring.png'
  },
  {
    title: "Enterprise Grade Security",
    content: <p>Lumio is built with security in mind.
      Out entire platform is hosted on Amazon's secure cloud servers and we encrypt all communications with SSL.
      Audit trail logs is available upon request.</p>,
    image: '//cdn.lumio.id/w500/topng/s3:ap-southeast-1:lumio:web/EnterpriseSecurity.png',
    position: 'left'
  }
];


export default class Features extends Component {

  renderLeft(section) {
    return (
      <section>
        <div className="col-md-6 features-image">
          <Image src={section.image}/>
        </div>
        <div className="col-md-6">
          <h2>
            {section.title}
            <hr/>
          </h2>
          {section.content}
        </div>
      </section>
    )
  }

  renderRight(section) {
    return (
      <section>
        <div className="col-md-6">
          <h2>
            {section.title}
            <hr/>
          </h2>
          {section.content}
        </div>
        <div className="col-md-6 features-image">
          <Image src={section.image}/>
        </div>
      </section>
    )
  }

  render() {
    return (
      <section>
        {sectionList.map((section, index) => {
          const className = index === 0 ? 'push-top' : '';
          const innerClassName = index === 0 ? "bg-white" : '';
          return (
            <Content key={index}
                     innerClassName={innerClassName}
                     className={classNames(className, (index % 2 !== 0) && 'bg-grey')}>
              <div className="row">
                {section.position === 'left' ? this.renderLeft(section) : this.renderRight(section)}
              </div>
            </Content>
          )
        })}
        <Content className="bg-black" style={{
          background: `url(//cdn.lumio.id/tojpg/s3:ap-southeast-1:lumio:web/img_bg_player.jpg) center center / cover`
        }}>
          <div className="row">
            <div className="col-md-6">
              <h2 className="white">
                Compact Hardware
                <hr/>
              </h2>
            </div>
            <div className="col-md-6">
              <p>It's small we know, but what's inside that counts.
                Our tiny player is powerful enough to display any contents that you throw at it.</p>
              <Image src='//cdn.lumio.id/topng/s3:ap-southeast-1:lumio:web/img_player.png'
                     style={{ width: '100%', marginTop: '50px' }}/>
            </div>
          </div>
        </Content>
      </section>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/Features.js